import { Asset } from './Asset';

export interface SiteImage {
  id: number;
  key: string;
  label: string;
  asset: Asset | null;
  ctaUrl: string | null;
  ctaVisible: boolean;
}

export const SiteImageKey = {
  HERO: 'hero',
  HERO_MOBILE: 'hero-mobile',
  ABOUT_US: 'about-us',
  ARENA: 'arena',
  LOCATION: 'location',
  SESSIONS_INFO: 'sessions-info',
  COUPONS: 'coupons',
  SURFER_WEEK_POPUP: 'surfer-week-popup',
  NEWSLETTER_POPUP: 'newsletter-popup',
};

// The homepage builds its list from all ten session slots and then drops three of
// them (see indicesToRemove in HomePage), so nothing on the public side renders
// these slots and there is nothing to manage for them in the admin.
const UNRENDERED_SITE_IMAGE_KEYS = ['session-5', 'session-6', 'session-8'];

export const getManageableSiteImages = (
  siteImages: SiteImage[] | null,
): SiteImage[] | null =>
  siteImages?.filter(
    (siteImage) => !UNRENDERED_SITE_IMAGE_KEYS.includes(siteImage.key),
  ) ?? null;

export const getSiteImage = (
  siteImages: SiteImage[] | null,
  key: string,
): SiteImage | null =>
  siteImages?.find((siteImage) => siteImage.key === key) ?? null;

export const getSiteImageUrl = (
  siteImages: SiteImage[] | null,
  key: string,
  fallback: string,
): string => getSiteImage(siteImages, key)?.asset?.location ?? fallback;

export const getSiteImageThumbUrl = (siteImage: SiteImage): string | null =>
  siteImage.asset?.thumbLocation ?? siteImage.asset?.location ?? null;
